<template>
  <div class="page-not-found intro-component-animation">
    <div class="container">
      <div class="header d-flex">
        <div class="texts">
          <span class="text_style"> Whoops ... </span>
          <p class="mt-4" style="color:rgba(34, 34, 34, 0.7)">
            Sorry, we couldn't find the page you're looking for.<br />
            Take a deep breath, get centered, and let's get you back home.
          </p>
          <br />
          <router-link to="/" style="text-decoration: none">
            <v-btn depressed dark color="#00558E" class="py-6 px-7"
              ><v-icon  class=" pl-0 pa-3" color="white">mdi-home</v-icon>
              <span style="color: white" class="mt-1">BACK TO HOME </span>
            </v-btn>
          </router-link>
        </div>

        <div class="image" style="margin-right:160px">
          <img src="img/page-not-found-oldman.png" />
        </div>
      </div>

      <!-- <div class="boxes">
        <v-row>
          <v-col cols="12" md="4">
            <v-card class="pa-5">
              <h5 class="style_etx mt-0">
                <v-icon> mdi-message-reply-text</v-icon
                ><span> Get in touch </span>
              </h5>
              <p class="body-2 style_text_p">
                Lorem ipsum dolor sit Lorem ipsum dolor sit amet consectetur
                adrpoiding
              </p>
              <a href="" class="link"
                ><span>Leave a message</span>
                <v-icon>mdi-arrow-right-thick </v-icon></a
              >
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="pa-5">
              <h5 class="style_etx mt-0">
                <v-icon> mdi-emoticon-outline</v-icon
                ><span> Help & Support</span>
              </h5>
              <p class="body-2 style_text_p">
                2750 Stickney Point Rd. Suite #203 Sarasota, Florida 34231 USA
              </p>
              <a href="" class="link"
                ><span>Request a meet</span>
                <v-icon color="blue">mdi-arrow-right-thick</v-icon></a
              >
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="pa-5">
              <h5 class="style_etx mt-0">
                <v-icon>mdi-bug</v-icon><span> Media & Press </span>
              </h5>
              <p class="body-2 style_text_p">
                If you find bugs or problems, be a hero and help us improve the
                experience for everyone!
              </p>
              <a href="" class="link"
                ><span>Email us to press@bodytalk.com</span>
                <v-icon color="blue">mdi-arrow-right-thick</v-icon></a
              >
            </v-card>
          </v-col>
        </v-row>
      </div> -->
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name : "ErrorPage"
});
</script>

<style scoped>
.text_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;

  display: flex;
  align-items: center;

  color: #222222;
}
</style>
